import { defineMessages } from 'react-intl';

const messages = defineMessages({
  featuresLabel: {
    description: 'Label for features that are included in the plan',
    defaultMessage: 'FEATURES',
    id: 'XYAd/7',
  },
  supportMessage: {
    description: 'Message denoting types of support included in the plan',
    defaultMessage: '{supportTypes} support',
    id: 'As/Ld6',
  },
  singularShipmentsMessage: {
    description: 'Message for singular shipment option',
    defaultMessage: '{numOfShipments} shipments a month',
    id: 'FJatmX',
  },
  unlimitedShipmentsMessage: {
    description: 'Message for unlimited shipments',
    defaultMessage: 'Unlimited shipments*',
    id: '50kKKh',
  },
  untilMessage: {
    description: 'Message for the until dropdown option',
    defaultMessage: 'Until {date}',
    id: 't5IG84',
  },
  brandingMessage: {
    description: 'Message for customized packing slips included in the plan',
    defaultMessage: 'Customized Packing Slips',
    id: 'OrpJ6u',
  },
});

export default messages;
